import { render } from "./IntertextsOverview.vue?vue&type=template&id=8c5f5f92&ts=true"
import script from "./IntertextsOverview.vue?vue&type=script&lang=ts"
export * from "./IntertextsOverview.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__